import { AutogenModelDrsManSettlement, AutogenRowDrsManSettlement } from "./autogen/AutogenModelDrsManSettlement";

export class ModelDrsManSettlement extends AutogenModelDrsManSettlement<RowDrsManSettlement> {
	constructor() {
		super(RowDrsManSettlement);
	}
}

export class RowDrsManSettlement extends AutogenRowDrsManSettlement {
}